import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";

import { FixedTabs } from "./FixedTabs";

interface FixedTabsContainerProps {
    defaultTabByValue?: string;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: FixedTabsContainerProps) => {
    const controlModel = ownProps.viewModelSelect.controlModel(state, ownProps.defaultTabByValue ?? "");
    return { defaultTabNameInInner: controlModel.value };
};

export const FixedTabsContainer = withViewModelSelect(connect(mapStateToProps)(FixedTabs));
